import HomeVM from './home-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    const data = JSON.parse(node.dataset.homeData);
    const vm = new Vue(HomeVM);
    vm.bindData(data);
    vm.$mount(node);
  }
};
